import { t } from 'ttag'
import { v4 as uuidv4 } from 'uuid'

import { Edit3Icon } from 'components/shared/Icon/model'

const INVITATION = 'invite.mail'
const REMINDER = 'reminder.mail'
const TALENT_ASSESSMENT_INVITATION = 'invite.talent_assessment.mail'
const TALENT_ASSESSMENT_REMINDER = 'reminder.talent_assessment.mail'

export const ACTION_EDIT = 'ACTION_EDIT'

export const MESSAGE_TYPES = { INVITATION, REMINDER }

export const getColumns = () => [
  { header: t`name`, alignLeft: true },
  { header: t`message type` },
  { header: t`language` },
  { header: t`created`, accessorKey: 'creation_date' },
  { header: t`department`, accessorKey: 'department' },
  { header: '', id: uuidv4() },
]

export const getRowActions = () => [
  { icon: Edit3Icon, label: t`Edit`, type: ACTION_EDIT },
]

export const getMessageTypeLabel = state => {
  const { message_type } = state

  const labels = {
    [MESSAGE_TYPES.INVITATION]: t`Candidate invitation`,
    [MESSAGE_TYPES.REMINDER]: t`Candidate reminder`,
    [TALENT_ASSESSMENT_INVITATION]: t`Career assessment invitation`,
    [TALENT_ASSESSMENT_REMINDER]: t`Career assessment reminder`,
  }

  return labels[message_type]
}
